var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gotoshop"},[_c('a',{attrs:{"href":"https://b2b.baidu.com/aitf/shop?name=%E5%A8%B2%E7%9F%B3%E6%B0%B4%E6%B3%A5%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&tpath=index","target":"_blank"}},[_vm._v("跳转商城")])])
}]

export { render, staticRenderFns }